// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPolicyForm_page__Tdyil","frame":"PrivacyPolicyForm_frame__HnBhV"};